import { createFileRoute } from '@tanstack/react-router';
import { NotFoundError } from '@/features/errors/not-found-error';

export const Route = createFileRoute('/(errors)/404')({
    head: () => ({ meta: [{ title: 'Page not found | promote.fun' }] }),
    component: NotFoundError,
});
